import { useStore } from '@stores';
import { useEffect } from 'react';

export const useServiceHistory = (id: string | undefined) => {
  const { serviceHistoryStore } = useStore();
  const { serviceHistory, loading } = serviceHistoryStore;

  useEffect(() => {
    id && serviceHistoryStore.get({ id });

    return () => {
      serviceHistoryStore.clearServiceHistory();
    };
  }, [serviceHistoryStore, id]);

  return { serviceHistory, loading };
};
